export default __webpack_public_path__ + "static/media/3DShape_03.cd2ae01f.png";